/**
 * Component Entry
 *
 */

import Dialog from './Dialog'
export default Dialog
export * from './Dialog'
